import React from 'react';

var Search = function Search(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.692 15.333a5.641 5.641 0 1 0 0-11.282 5.641 5.641 0 0 0 0 11.282zm6.117-.975l5.89 5.891a1.026 1.026 0 0 1-1.45 1.45l-5.89-5.89a7.692 7.692 0 1 1 1.45-1.45z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Search.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Search as icon };
export default iconHandler(Search);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Search.js
// module id = 622
// module chunks = 0